import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Optional } from 'typescript-optional';
import { FilesDetailsRequest } from '../../../../../models/file-image';
import { GenericDocSearchCriteriaDtoModel } from '../../data-transfer-objects/generic-doc-search-criteria.model';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from './api-response.model';
import { ApiVisa } from './api-visa.model';
import { Pagination } from './pagination.model';
import { DepositRequisitionSearchCriteriaDtoModel, DepositRegisterSearchCriteriaDtoModel, DepositRegisterTxnLineSearchCriteriaDtoModel } from '../../data-transfer-objects';
import { DepositCategorySearchCriteriaDtoModel } from '../../data-transfer-objects/deposit-category-search-criteria.model';


export class BaseApiTemplateService<T> {
  protected apiUrl: string;
  protected api_domain_url: string;
  protected endpoint_path: string;
  protected endpoint_path_public_url: string;
  protected endpoint_path_login_url: string;
  protected endpoint_path_login_entity_url: string;
  protected endpoint_path_sysadmin_url: string;
  protected endpoint_path_event_view_url: string;
  protected endpoint_path_website_ep_url: string;

  static readonly BACKOFFICE_EP = 'backoffice-ep';
  static readonly LOGIN_ENTITY_EP = 'login-entity-ep';
  static readonly LOGIN_EP = 'login-ep';
  static readonly SYSADMIN_EP = 'sysadmin-ep';
  static readonly PUBLIC_EP = 'public-ep';
  static readonly WEBSITE_EP = 'website-ep';
  static readonly TENANT_ADMIN_EP = 'tenant-admin-ep';

  protected httpClient: HttpClient;

  constructor() {
  }

  public getApiUrl() {
    return this.apiUrl;
  }

  public getHttpHeader(apiVisa: ApiVisa) {
    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode
      ? apiVisa.tenantCode
      : '';

    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode, /// this will be removed in the future
        appId: apiVisa.applet_code, /// this will be removed in the future
        // jwt_secret: apiVisa.jwt_secret,
        // tenantCode: apiVisa.tenantCode,
        // applet_code: apiVisa.applet_code
      })
    };

    return httpOptions;
  }

  public getHttpHeaderBlob(apiVisa: ApiVisa, params?: HttpParams) {
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        responseType: 'blob',
        tenantCode: apiVisa.tenantCode
      }),
      params: params,
      responseType: 'blob' as 'json'
    };
    return httpOptions;
  }

  public getHttpHeaderText(apiVisa: ApiVisa) {
    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode ? apiVisa.tenantCode : '';

    const httpOptions: Object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode,
      }),
      responseType: 'text',
    };
    return httpOptions;
  }

  public getHttpHeaderJson(apiVisa: ApiVisa) {
    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode ? apiVisa.tenantCode : '';

    const httpOptions: Object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode,
      }),
      responseType: 'json',
    };
    return httpOptions;
  }

  public getHttpHeaderAccessKey(apiVisa: ApiVisa) {
    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode
      ? apiVisa.tenantCode
      : '';

    const httpOptions = {
      headers: new HttpHeaders({
        accessId: apiVisa.AccessID,
        accessKey: apiVisa.AccessKey,
        tenantCode: apiVisa.tenantCode,
        appId: apiVisa.applet_code
      })
    };

    return httpOptions;
  }

  //////// Save methods //////////
  public post(dtoObject: T, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public postLoginEntityEp( dtoObject: T, visa: ApiVisa): Observable<BasicApiResponseModel<T>> {
    if (this.endpoint_path_login_entity_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_entity_url;
    }
    return this.httpClient.post<BasicApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public postPublicEp(dtoObject: T, visa: ApiVisa): Observable<BasicApiResponseModel<T>> {
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
    }
    return this.httpClient.post<BasicApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public postWithAttachments(dtoObject: FormData, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public postFileUploadETLWithAttachments(dtoObject: FormData, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      if(visa.api_domain_url.includes('api.akaun.com')) {
        this.apiUrl = visa.api_domain_url.replace('api.akaun.com','api-etl.akaun.com') + this.endpoint_path;
      }else{
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public putWithAttachments(dtoObject: FormData, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<ApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public postOne(dtoObject: T, visa: ApiVisa): Observable<BasicApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


  public postOnePromise(dtoObject: T, visa: ApiVisa): Promise<BasicApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  public postPromise(dtoObject: T, visa: ApiVisa): Promise<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    ).toPromise();
  }

  /** GET branches from the server */
  public get(visa: ApiVisa): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<T>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

  public getPromise(visa: ApiVisa): Promise<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<T>>(this.apiUrl, this.getHttpHeader(visa))
      .toPromise();
  }

  /** Edit branch */
  //////// Save methods //////////
  public edit(dtoObject: T, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<ApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public editPromise(dtoObject: T, visa: ApiVisa): Promise<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<ApiResponseModel<T>>(this.apiUrl, dtoObject, this.getHttpHeader(visa))
      .toPromise();
  }

  /** Edit for BasicApiResponseModel */
  //////// Save methods //////////
  public put(dtoObject: T, visa: ApiVisa): Observable<BasicApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<T>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  /** Delete branch */
  public delete(guid: string, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<T>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public deletePromise(guid: string, visa: ApiVisa): Promise<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<T>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    ).toPromise();
  }



  /** File Attachment related */
  addAttachmentsAndDetails(guid: string, files: File[], visa: ApiVisa,
    filesDetails?: FilesDetailsRequest) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    files.forEach(file => formData.append('files', file));
    if (filesDetails) {
      formData.set(
        'files-data',
        new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
        'files-data.json')
    }

    return this.httpClient.put<ApiResponseModel<T>>(
      this.apiUrl + '/add-files/' + guid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  public editAttachmentAndDetails(extensionGuid: string, file: File, visa: ApiVisa,
    filesDetails: Optional<FilesDetailsRequest>): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file);
      filesDetails.ifPresent(details =>
        formData.set(
          'file-data',
          new Blob([JSON.stringify(details)], { type: 'application/json' }),
          'file-data.json'));
    }

    return this.httpClient.put<ApiResponseModel<T>>(
      this.apiUrl + '/replace-file/' + extensionGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  public deleteAttachment(extensionGuid: string, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<T>>(
      this.apiUrl + '/file/' + extensionGuid,
      this.getHttpHeader(visa)
    );
  }

  public getAttachmentFile(extensionGuid: string, apiVisa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/file/' + extensionGuid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }


  /** Get branch by guid */
  public getByGuid(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<T>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public getByGuidPromise(
    guid: string,
    visa: ApiVisa
  ): Promise<BasicApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<T>>(this.apiUrl + '/' + guid, this.getHttpHeader(visa))
      .toPromise();
  }

  public getByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<T>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaPublicEp(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<T>> {
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<T>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaLoginEntityEp(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<T>> {
    if (this.endpoint_path_login_entity_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_entity_url;
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<T>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  protected __getByGuidAux<U>(
    apiUrl: string,
    guid: string,
    visa: ApiVisa): Observable<BasicApiResponseModel<U>> {

    const endpointUrl = apiUrl == null || apiUrl === '' ? this.apiUrl : apiUrl;
    const UrlByGuid = endpointUrl + '/' + guid;

    return this.httpClient.get<BasicApiResponseModel<U>>(
      UrlByGuid,
      this.getHttpHeader(visa)
    );
  }

  protected __getByCriteriaAux<U>(
    apiUrl: string,
    pagination: Pagination,
    visa: ApiVisa
  ): Observable<PagingResponseModel<U>> {
    const endpointUrl = apiUrl == null || apiUrl === '' ? this.apiUrl : apiUrl;
    const UrlByCriteria = endpointUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<U>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }


  protected __postLoginAux<U>(
    apiUrl: string,
    dtoObject: U,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<U>> {
    const endpointUrl = apiUrl == null || apiUrl === '' ? this.apiUrl : apiUrl;
    return this.httpClient.post<BasicApiResponseModel<U>>(
      endpointUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public __deleteLoginAux<U>(apiUrl: string, guid: string, visa: ApiVisa): Observable<ApiResponseModel<U>> {
    const endpointUrl = apiUrl == null || apiUrl === '' ? this.apiUrl : apiUrl;
    const UrlByGuid = endpointUrl + '/' + guid
    return this.httpClient.delete<ApiResponseModel<U>>(
      UrlByGuid,
      this.getHttpHeader(visa)
    );
  }

  public __deleteAux<U>(apiUrl: string, guid: string, visa: ApiVisa): Observable<ApiResponseModel<U>> {
    const endpointUrl = apiUrl == null || apiUrl === '' ? this.apiUrl : apiUrl;
    const UrlByGuid = endpointUrl + '/' + guid
    
    return this.httpClient.delete<ApiResponseModel<U>>(
      UrlByGuid,
      this.getHttpHeader(visa)
    );
  }

  protected __putLoginEntityAux<U>(
    apiUrl: string,
    dtoObject: U,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<U>> {
    const endpointUrl = apiUrl == null || apiUrl === '' ? this.apiUrl : apiUrl;
    return this.httpClient.put<BasicApiResponseModel<U>>(
      endpointUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  protected __getAllAux<U>(
    apiUrl: string,
    visa: ApiVisa): Observable<ApiResponseModel<U>> {

    const endpointUrl = apiUrl == null || apiUrl === '' ? this.apiUrl : apiUrl;

    return this.httpClient.get<ApiResponseModel<U>>(
      endpointUrl,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaPromise(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Promise<PagingResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<T>>(UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  public getByCriteriaSnapshot(
    pagination: Pagination,
    visa: ApiVisa,
  ): Observable<PagingResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query/snapshot?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<T>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
  
  public getByCriteriaSnapshotV2(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query/snapshot-v2/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getBySnapshotQuery(dtoObject: GenericDocSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query/snapshot';
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getBySnapshotCustomQuery(dtoObject: GenericDocSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/custom/query/snapshot/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getBySnapshotCustomHdrQuery(dtoObject: GenericDocSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/custom/query/snapshot-hdr/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getBySnapshotCustomHdrLinesQuery(dtoObject: GenericDocSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/custom/query/snapshotHdrLines/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getBySnapshotCountQuery(dtoObject: GenericDocSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/custom/query/snapshot-total-records/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaSnapshotPromise(
    pagination: Pagination,
    visa: ApiVisa
  ): Promise<PagingResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/query/snapshot?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<T>>(UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  public getCountByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
  ): Observable<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/query/count?' + pagination.getQueryKeyValues();
    return this.httpClient.get<ApiResponseModel<T>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getCountByCriteriaPromise(
    pagination: Pagination,
    visa: ApiVisa
  ): Promise<ApiResponseModel<T>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/query/count?' + pagination.getQueryKeyValues();
    return this.httpClient.get<ApiResponseModel<T>>(UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  /** Print Jasper Pdf */
  public printJasperPdfFile(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string): Observable<Blob> {
    let params;
    if (customParam) {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid)
        .set('customParam', customParam);
    } else {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid);
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/print-jasper-pdf/' + guid,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  public updatePostingStatus(dtoObject: T, apiVisa: ApiVisa, guid: string) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<T>>(
      this.apiUrl + '/update-posting-status/' + guid,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }

  public updateFarHdrGuid(genDocHdrGuid: string, farHdrGuid: string, apiVisa: ApiVisa) {

    apiVisa.applet_code = apiVisa.applet_code ? apiVisa.applet_code : 'none';
    apiVisa.tenantCode = apiVisa.tenantCode
      ? apiVisa.tenantCode
      : '';

    const httpOptions = {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        tenantCode: apiVisa.tenantCode, /// this will be removed in the future
        appId: apiVisa.applet_code, /// this will be removed in the future
        'Content-Type': 'application/json',
      })
    };

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const fullUrl = this.apiUrl + '/update-fixed-asset?genDocHdrGuid=' + genDocHdrGuid + '&farHdrGuid=' + farHdrGuid;
    return this.httpClient.put<BasicApiResponseModel<any>>(
      fullUrl,
      null,
      httpOptions
    );
  }

  public getDepositRequisitionBySnapshotCustomQuery(dtoObject: DepositRequisitionSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query';
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getDepositRegisterBySnapshotCustomQuery(dtoObject: DepositRegisterSearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/post-query';
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getRolloverBySnapshotCustomQuery(dtoObject: DepositRegisterTxnLineSearchCriteriaDtoModel, visa: ApiVisa): Observable<PagingResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query/post';
    }
    return this.httpClient.post<PagingResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getDepositCategoryBySnapshotCustomQuery(dtoObject: DepositCategorySearchCriteriaDtoModel, visa: ApiVisa): Observable<ApiResponseModel<T>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query/post';
    }
    return this.httpClient.post<ApiResponseModel<T>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
